module.exports = __webpack_public_path__ + "img/about-position-header.jpg?0e5a02ffbd7421d4f81eb830942a72cd";